import { render, staticRenderFns } from "./ImageMessageBalloon.vue?vue&type=template&id=317e3998&scoped=true&"
import script from "./ImageMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./ImageMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./ImageMessageBalloon.vue?vue&type=style&index=0&id=317e3998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e3998",
  null
  
)

export default component.exports